import React from 'react';
import logo from '/public/images/arcadvantage-logo.png';

export default function Logo() {
  return (
    <div className="flex items-center space-x-2">
      <img src={logo} alt="Arc Advantage Logo" width={200}/>
    </div>
  );
}